// extracted by mini-css-extract-plugin
export default {"root":"styles_root__y9Wem","withLogoHidden":"styles_withLogoHidden__Q-Woo","whiteBackground":"styles_whiteBackground__OIDeK"};